var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ _vm.isMobile ? 'mobile-container' : '' ]},[_c('Render',{attrs:{"value":_vm.value,"isMobile":_vm.isMobile,"env":_vm.env}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }